import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Cpu, LogIn } from "lucide-react";

export default function AdminLogin() {
  const { user, login, error } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (user && user.role === "admin") navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await login(email, password);
    setLoading(false);
    if (ok) navigate("/admin", { replace: true });
  };

  return (
    <div className="min-h-[calc(100vh-8rem)] grid place-items-center px-4 py-14">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2.5 justify-center">
          <span className="grid place-items-center w-10 h-10 rounded-lg bg-slate-900 text-white">
            <Cpu className="w-5 h-5" />
          </span>
          <span className="font-display text-lg font-bold">Mymi<span className="text-blue-600">·</span>Global</span>
        </Link>
        <div className="mt-8 rounded-2xl bg-white border border-slate-200 p-8">
          <div className="text-xs font-semibold uppercase tracking-wider text-blue-600">Admin</div>
          <h1 className="mt-2 font-display text-2xl font-bold">Sign in to manage inventory</h1>
          <p className="mt-2 text-sm text-slate-600">Owner access to add, edit, and publish products.</p>

          <form onSubmit={submit} className="mt-6 space-y-3" data-testid="admin-login-form">
            <input required type="email" data-testid="admin-login-email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full px-4 py-3 rounded-lg border border-slate-200 focus:ring-2 focus:ring-blue-500 focus:outline-none" />
            <input required type="password" data-testid="admin-login-password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full px-4 py-3 rounded-lg border border-slate-200 focus:ring-2 focus:ring-blue-500 focus:outline-none" />
            {error && <div data-testid="admin-login-error" className="text-sm text-rose-600 bg-rose-50 border border-rose-200 rounded-lg px-3 py-2">{error}</div>}
            <button disabled={loading} data-testid="admin-login-submit" className="w-full inline-flex items-center justify-center gap-2 px-5 py-3 rounded-lg bg-slate-900 hover:bg-blue-600 disabled:opacity-60 text-white font-semibold transition-colors">
              <LogIn className="w-4 h-4" /> {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
